export { default as MyCryptoApiService } from './MyCryptoApi';
